import classNames from 'classnames';
import React from 'react';

import './HotspotLabel.css';

export function Label(props) {
  return (
    <div className={classNames('hotspot-label', { 
      'visible': props.visible,
      'starred': props.starred 
      })}>
      <div className="pill">
        <div className="plus"></div>
        <div className="star"></div>
        <div className="title">{props.children}</div>
      </div>
    </div>
  )
}